import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Loading placeholder for the coach's CoachingDashboard — mirrors its layout:
// gradient header, a row of stat cards, the Quick Navigation cards, and the
// two-column recent-students / activity panels.
export default function CoachingDashboardSkeleton({ isDarkMode }) {
    const cardCls = `rounded-2xl border p-4 ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200 shadow-sm"}`;
    const panelCls = `rounded-2xl border p-5 ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200 shadow-sm"}`;
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`min-h-screen ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
                <div className="max-w-5xl mx-auto px-4 py-8">
                    {/* Header banner */}
                    <div className="mb-8">
                        <Skeleton height={112} borderRadius={16} />
                    </div>

                    {/* Stats row (6 cards) */}
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-8">
                        {Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} className={cardCls}>
                                <Skeleton width={40} height={40} borderRadius={12} className="mb-3" />
                                <Skeleton width={48} height={26} />
                                <Skeleton width={64} height={12} className="mt-1" />
                            </div>
                        ))}
                    </div>

                    {/* Quick Navigation (heading + 5 cards) */}
                    <Skeleton width={160} height={22} className="mb-4" />
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mb-8">
                        {Array.from({ length: 5 }).map((_, i) => (
                            <div key={i} className={cardCls}>
                                <Skeleton width={40} height={40} borderRadius={12} className="mb-3" />
                                <Skeleton width={90} height={14} />
                                <Skeleton width={70} height={12} className="mt-1" />
                            </div>
                        ))}
                    </div>

                    {/* Two-column panels (recent students / activity) */}
                    <div className="grid gap-6 lg:grid-cols-2">
                        {Array.from({ length: 2 }).map((_, c) => (
                            <div key={c} className={panelCls}>
                                <div className="flex items-center justify-between mb-4">
                                    <Skeleton width={120} height={18} />
                                    <Skeleton width={60} height={14} />
                                </div>
                                <div className="space-y-2.5">
                                    {Array.from({ length: 5 }).map((_, r) => (
                                        <div key={r} className="flex items-center gap-3">
                                            <Skeleton width={36} height={36} borderRadius={10} />
                                            <div className="flex-1">
                                                <Skeleton width="55%" height={13} />
                                                <Skeleton width="75%" height={11} className="mt-1" />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </SkeletonTheme>
    );
}
